import React from "react";

// andywarhol.ai brand mark — a refined Warhol-style 2x2 pop-art tile
// with an elegant serif "aw" ligature. Self-contained colors so it reads
// on any background (light or dark header).
export const Logo = ({ className = "w-10 h-10" }) => {
  const id = React.useId().replace(/:/g, "");
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      role="img"
      aria-label="andywarhol.ai"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id={`clip-${id}`}>
          <rect width="120" height="120" rx="9" />
        </clipPath>
      </defs>
      <g clipPath={`url(#clip-${id})`}>
        <rect x="0" y="0" width="60" height="60" fill="#ECE3D0" />
        <rect x="60" y="0" width="60" height="60" fill="#211F1A" />
        <rect x="0" y="60" width="60" height="60" fill="#B2A793" />
        <rect x="60" y="60" width="60" height="60" fill="#C4381F" />
        <text
          x="35"
          y="86"
          textAnchor="middle"
          fontFamily="'Cormorant Garamond', Georgia, serif"
          fontSize="86"
          fontWeight="600"
          fill="#211F1A"
        >
          a
        </text>
        <text
          x="87"
          y="86"
          textAnchor="middle"
          fontFamily="'Cormorant Garamond', Georgia, serif"
          fontSize="86"
          fontWeight="600"
          fill="#ECE3D0"
        >
          w
        </text>
      </g>
      <rect x="1" y="1" width="118" height="118" rx="9" fill="none" stroke="rgba(0,0,0,0.12)" strokeWidth="1.5" />
    </svg>
  );
};
